module.exports = __webpack_public_path__ + "img/CM-MS-24-Buick-Playful.6369853e.jpg";